const baseUrl = `${process.env.PROTOCOL}${process.env.API_PORTAL_URL}`

export default baseUrl



// WEBPACK FOOTER //
// ./src/utils/base-url-portal.js